import { Events } from './services/events.service';
import { AlertService } from 'src/app/services/alert.service';
import { Component, OnInit } from '@angular/core';

import { Platform, NavController } from '@ionic/angular/standalone';
import { AuthService } from './services/auth.service';
import { addIcons } from "ionicons";
import { closeCircleOutline, person, gridSharp, homeSharp, logOut } from "ionicons/icons";
import { IonRouterLink } from "@ionic/angular/standalone";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    public selectedIndex = 0;
    public appPages = [
        { title: 'Home', url: '/home', icon: 'home', params:null },
        { title: 'ivform', url: '/ivform', icon: 'grid' },
        { title: 'ivgrid', url: '/ivgrid', icon: 'grid' },
        { title: 'Table', url: '/table', icon: 'grid' },

    ];

    constructor(
        private platform: Platform,
        private authService: AuthService,
        private alertService: AlertService,
        private navCtrl: NavController,
        private events: Events,
    ) {
        this.initializeApp();
        addIcons({ homeSharp, gridSharp, person, closeCircleOutline, logOut });
    }

    initializeApp() {
        this.platform.ready().then(() => {

            this.authService.getCredentials().then((cred) => {
                console.log("cred:" + JSON.stringify(cred) + ", gotuser:" + this.authService.gotUser);
                if (this.authService.APP_TYPE == 'mobile' && this.authService.gotUser == true) {
                    this.events.publish('appinit', cred);
                }
            })
        });

    }

    ngOnInit() {

    }

    // When Logout Button is pressed 
    logout() {
        this.authService.logout().then((data) => {
            this.alertService.popupToast('Logged out', 2000);
            this.navCtrl.navigateRoot('/login');
        },
            (error) => {
                console.log(error);
            });
    }

}
